<template>
  <i18n-t keypath="PostListItemWherePosted.whoPostedInGroup" tag="div" class="d-flex flex-shrink-1 font-size-small gap-1" scope="global">
    <template #who>
      <div class="font-weight-bold" :class="{ 'ml-n1': post.content && skipAuthorIfNoContent }">
        <user-profile-link :user-id="post.author.id">
          <div class="d-flex align-center gap-1">
            <user-avatar v-if="!post.content" :user="post.author" :size="16" />
            <div v-if="!skipAuthorIfNoContent">{{ post.author.display_name }}</div>
          </div>
        </user-profile-link>
      </div>
    </template>
    <template #in>
      <div class="flex-grow-0 flex-shrink-0">{{ $translate("PostListItemWherePosted.in") }}</div>
    </template>
    <template #where>
      <div class="post-group-name">
        <router-link :to="{ name: $routes.GROUPS, params: { groupId: post.wall } }">
          {{ postGroupName }}
        </router-link>
      </div>
    </template>
  </i18n-t>
</template>

<script>
import { mapGetters } from "pinia"

import { useGroupsStore } from "@/store/groups.js"

export default {
  props: {
    post: {
      type: Object,
      required: true
    },
    skipAuthorIfNoContent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(useGroupsStore, ["groupForKey"]),
    postGroupName() {
      return this.groupForKey(this.post.wall)?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.post-group-name {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
</style>
